export class GeminiClient {
  constructor(
    debug = false,
    hardwareId = "",
    url = "",
    secret = "",
    version = "",
  ) {
    this.listener = null;
    this.debug = debug;
    this.hardwareId = hardwareId;
    this.secret = secret;
    this.url = url;
    //this.url = "http://127.0.0.1:5001/bqn-chatbox/us-central1/BRANCH_FUNC_NAME";
    //this.url = "https://us-central1-bqn-chatbox.cloudfunctions.net/geminiSendContent_jarroyo_R5_0_3703"
    this.version = version;
    this.receivedMessage = "";
  }

  listen(callback) {
    this.listener = callback;
  }

  stopListen() {
    this.listener = null;
  }

  async sendMessage(message, history, mode) {
    if (this.debug) {
      console.info("Gemini (user):", message);
    }

    this.receivedMessage = "";

    try {
      const response = await fetch(
        `${this.url}?hardwareId=${encodeURIComponent(
          this.hardwareId,
        )}&version=${encodeURIComponent(
          this.version,
        )}&mode=${encodeURIComponent(mode)}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: this.secret,
          },
          body: JSON.stringify({
            question: message,
            history,
            location: location.pathname,
            managementIpAddress: location.host,
          }),
        },
      );

      this.receivedMessage = (await response.json()).text;

      if (!this.receivedMessage) {
        throw new Error("Empty message");
      }

      if (this.listener) {
        this.listener(this.receivedMessage);
      }

      return;
    } catch (err) {
      console.error("Gemini error:", err);
      if (this.listener) {
        this.listener(
          "Oops, the AI agent is not available at this moment, try it later. Please refer to the <a href='https://www.bequant.com/docs/' target='_blank'> documentation site </a> for more information.",
        );
      }
    }
  }
}
